import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: () => {
      const user = localStorage.getItem('user');
      if (user) {
        try {
          const { role } = JSON.parse(user);
          if (role === 'superadmin') return '/superadmin/dashboard';
          if (role === 'societyadmin') return '/societyadmin/dashboard';
        } catch (e) { /* fall through */ }
      }
      return '/superadmin/login';
    }
  },
  {
    path: "/superadmin/login",
    name: "superadminLogin",
    component: () => import("../components/superadmin/auth/Login"),
  },
  {
    path: "/superadmin/forgotPassword",
    name: "superadminForgotPassword",
    component: () => import("../components/superadmin/auth/ForgotPassword"),
  },
  {
    path: "/superadmin/resetPassword/:token",
    name: "superadminResetPassword",
    component: () => import("../components/superadmin/auth/ResetPassword"),
  },
  {
    path: "/privacy-policy",
    name: "superadminPrivacy",
    component: () => import("../components/superadmin/auth/Privacy-policy"),
  },
  {
    path: "/term-condition",
    name: "superadminTerm",
    component: () => import("../components/superadmin/auth/Terms-condition"),
  },
  {
    path: "/refund-policy",
    name: "superadminRefund",
    component: () => import("../components/superadmin/auth/Refund-policy"),
  },

  {
    path: "/superadmin/",
    name: "superadminHome",
    component: () => import("../components/superadmin/layouts/layout"),
    children: [
      {
        path: "settings",
        name: "superadminSettings",
        component: () => import("../components/superadmin/Settings.vue"),
      },
      {
        path: "changePassword",
        name: "superadminChangePassword",
        component: () => import("../components/superadmin/auth/ChangePassword"),
      },
      {
        path: "profile",
        name: "superadminProfile",
        component: () => import("../components/superadmin/Profile"),
      },
      {
        path: "society/requests",
        name: "superadminSocietyRequests",
        component: () => import("../components/superadmin/society/Requests"),
      },
      {
        path: "society/requests/:id/details",
        name: "superadminSocietyRequestDetails",
        component: () =>
          import("../components/superadmin/society/AcceptRejectRequest"),
      },
      {
        path: "society/list",
        name: "superadminSocietyList",
        component: () => import("../components/superadmin/society/List"),
      },

      {
        path: "society/list/:id/details",
        name: "superadminSocietyDetail",
        component: () => import("../components/superadmin/society/Details"),
      },
      {
        path: "modules",
        name: "superadminModules",
        component: () => import("../components/superadmin/Modules"),
      },
      {
        path: "manage-admins",
        name: "superadminManageAdmins",
        component: () => import("../components/superadmin/SuperAdmins"),
      },
      {
        path: "feedback",
        name: "superadminFeedback",
        component: () => import("../components/superadmin/Feedback"),
      },
      {
        path: "plan",
        name: "superadminPlanList",
        component: () => import("../components/superadmin/society/plan/list"),
      },

      {
        path: "payment",
        name: "superadminPayment",
        component: () => import("../components/superadmin/Payment"),
      },
      {
        path: "faqs",
        name: "superadminFaqsList",
        component: () => import("../components/superadmin/faq/List"),
      },
      {
        path: "faq-categories",
        name: "superadminFaqCategoriesList",
        component: () => import("../components/superadmin/faq/CategoryList"),
      },

      {
        path: "app-versions",
        name: "superadminAppVersions",
        component: () => import("../components/superadmin/AppVersion"),
      },

      {
        path: "contact-queries",
        name: "superadminContactQueries",
        component: () => import("../components/superadmin/ContactQueries"),
      },

      {
        path: "privacy",
        name: "superadminPrivacyPolicy",
        component: () => import("../components/superadmin/PrivacyPolicy"),
      },

      {
        path: "term_condition",
        name: "superadminTermsCondition",
        component: () => import("../components/superadmin/TermsCondition"),
      },

      {
        path: "refund_policy",
        name: "superadminRefundPolicy",
        component: () => import("../components/superadmin/RefundPolicy"),
      },

      {
        path: "dashboard",
        name: "superadminDashboard",
        component: () => import("../components/superadmin/Dashboard"),
      },

    ],
  },

  {
    path: "/superadmin/404",
    name: "superadmin404",
    component: () => import("../components/superadmin/404"),
  },

  {
    path: "*",
    name: "notfound",
    component: () => import("../components/404"),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  let isAuthenticated = false;
  let role;
  let user = localStorage.getItem("user");

  if (user) {
    isAuthenticated = true;
    user = JSON.parse(user);
    role = user.role;
  }

  const NonAuthRoutesForSuperAdmin = [
    "superadminLogin",
    "superadminForgotPassword",
    "superadminResetPassword",
  ];
  const NonAuthRoutesForSocietyAdmin = [
    "societyadminLogin",
    "societyadminVerifyOtp",
  ];

  const CmsRoute = [
    "superadminPrivacy",
    "superadminTerm",
    "superadminRefund"
  ]
  if (CmsRoute.includes(to.name)) {
    next();
    return;
  }
  if (NonAuthRoutesForSuperAdmin.includes(to.name) && !isAuthenticated) {
    next();
    return;
  } else if (NonAuthRoutesForSocietyAdmin.includes(to.name) && !isAuthenticated) {
    next();
    return;
  }

  if (
    !NonAuthRoutesForSuperAdmin.includes(to.name) &&
    !isAuthenticated &&
    to?.path?.startsWith("/superadmin")
  ) {
    next({ path: "/superadmin/login" });
    return;
  } else if (
    !NonAuthRoutesForSocietyAdmin.includes(to.name) &&
    !isAuthenticated &&
    to?.path?.startsWith("/societyadmin")
  ) {
    next({ path: "/societyadmin/login" });
    return;
  }

  if (
    NonAuthRoutesForSuperAdmin.includes(to.name) &&
    isAuthenticated &&
    role == "superadmin"
  ) {
    next({ path: "/superadmin/dashboard" });
    return;
  } else if (
    NonAuthRoutesForSocietyAdmin.includes(to.name) &&
    isAuthenticated &&
    role == "societyadmin"
  ) {
    next({ path: "/societyadmin/dashboard" });
    return;
  }

  if (
    role == "superadmin" &&
    isAuthenticated &&
    to.path.startsWith("/superadmin/")
  ) {
    next();
    return;
  } else if (
    role == "societyadmin" &&
    isAuthenticated &&
    to.path.startsWith("/societyadmin/")
  ) {
    next();
    return;
  } else {
    // Prevent infinite loop — if role is unknown or undefined, go to login
    if (!role || (role !== 'superadmin' && role !== 'societyadmin')) {
      localStorage.removeItem('user');
      next({ path: '/superadmin/login' });
      return;
    }
    next({ path: '/' + role + '/dashboard' });
  }
});

export default router;
